import { render, staticRenderFns } from "./Tester.vue?vue&type=template&id=d86b1160&scoped=true&"
import script from "./Tester.vue?vue&type=script&lang=js&"
export * from "./Tester.vue?vue&type=script&lang=js&"
import style0 from "./Tester.vue?vue&type=style&index=0&id=d86b1160&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d86b1160",
  null
  
)

export default component.exports